<template>
    <div>
        <BlackWeekBanner />

        <div v-if="isWheelActive" class="relative">
            <div class="absolute inset-0 overflow-hidden pointer-events-none hidden sm:block">
                <WheelOfFortuneDecoration class="absolute -top-24 -left-32 z-10 transform -scale-x-100" />
                <WheelOfFortuneDecoration class="absolute -top-8 -right-12 z-10" />
            </div>
            <section class="relative rounded-b-3xl overflow-hidden text-white p-3 sm:p-8 md:p-12 lg:p-16">
                <div class="absolute inset-0 rounded-b-3xl overflow-hidden bg-[#0b1220]">
                    <img :src="$asset('/hkcm/images/BackgoundLights.png', 'public')" aria-hidden="true" class="absolute top-0 left-0 w-full object-contain object-top pointer-events-none opacity-50" />
                    <div
                        aria-hidden="true"
                        class="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_60%_at_15%_20%,#243b70_0%,transparent_60%),radial-gradient(60%_60%_at_85%_80%,#1d2a52_0%,transparent_60%)]"
                    />
                    <WheelSparkles />
                </div>
                <div class="relative">
                    <WheelOfFortuneLandingPage
                        :end-at="wheel?.end"
                        :start-at="wheel?.start"
                        :min-order-value="wheel?.minOrderValue"
                        class="lg:w-[calc(100%-380px)]"
                    ></WheelOfFortuneLandingPage>
                </div>
            </section>
        </div>

        <div v-if="isRaffleActive" class="container mx-auto mt-8">
            <RaffleProductBannerSlider class="lg:w-[calc(100%-380px)]" />
        </div>
        <Popup :open="popupOpen" :padding="true" @open="popupOpen = !popupOpen">
            <ProductMini
                :product-group="data"
                :product-category="productCategory"
                :pre-selected-variant="variant"
                :pre-selected-written="selectedProductVariant"
                :pre-selected-webinar="selectedWebinar"
                @open="closePopup"
            />
        </Popup>

        <div class="hidden lg:block max-w-[380px] right-1 sticky shadow-lg rounded-md bg-white" :class="[cartStyles, blackweekItemActive() ? 'h-[68vh]' : 'h-[80vh]']">
            <Cart :open="true" class="p-4 pb-8">
                <div class="flex flex-row justify-between items-center">
                    <h2 class="large_bold">
                        {{ $t('nav_cart') }}
                    </h2>
                    <span>
                        {{ $t('payment_count_articles', { count: $store.getters['cart/getCount'] }) }}
                    </span>
                </div>
            </Cart>
        </div>

        <div class="container mx-auto min-h-app pb-16 cursor-default select-none">
            <h1 class="xl4_bold py-8">
                {{ $t('product_world_alt') }}
            </h1>
            <!-- Desktop version -->
            <div class="hidden lg:grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 w-fit relative">
                <div ref="busstop" class="absolute w-full h-full"></div>
                <div v-for="(productCategory, index) in productCategories()" :key="productCategory.id" ref="box" class="w-fit relative shrink category">
                    <div class="w-[268px] rounded-lg py-2">
                        <div class="flex cursor-default select-none">
                            <ProductCategorySingleMid :key="productCategory.id" :data="productCategory" class="bg-white" />
                        </div>

                        <div v-if="!loading" class="bg-white mt-4 rounded-xl shadow-md">
                            <div class="grid grid-cols-1 box-inner place-items-center">
                                <ProductGroupDirect
                                    v-for="(product_group, index) in getProductGroupByProductCategoryId(productCategory.id)?.data.data"
                                    :key="product_group.id"
                                    ref="productGroupDirect"
                                    :data="product_group"
                                    :product-category="productCategory"
                                    :first="index === 0"
                                    class="transition-all ease-in-out duration-300 w-full"
                                    @shrink-other="shrink"
                                    @open-popup="openPopup"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mobile version -->
            <div class="lg:hidden product-slider overflow-hidden relative">
                <div class="flex flex-row justify-end gap-4 mb-2">
                    <div class="button-prev text-blue-dark cursor-pointer">
                        <Icon type="TailLeft" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
                    </div>
                    <div class="button-next text-blue-dark cursor-pointer">
                        <Icon type="TailRight" viewBox="0 0 30 21" width="25" height="26" fill="none" class="stroke-current" />
                    </div>
                </div>
                <div class="swiper-wrapper">
                    <div v-for="(productCategory, index) in productCategories()" :key="productCategory.id" ref="box" class="swiper-slide max-w-[284px] relative shrink category">
                        <div class="w-[268px] bg-orange-500i rounded-lg py-2">
                            <div class="flex cursor-default select-none">
                                <ProductCategorySingleMid :key="productCategory.id" :data="productCategory" />
                            </div>

                            <div class="bg-white mt-4 rounded-2xl shadow-xl">
                                <div class="grid grid-cols-1 box-inner place-items-center">
                                    <ProductGroupDirect
                                        v-for="(product_group, index) in getProductGroupByProductCategoryId(productCategory.id)?.data.data"
                                        :key="product_group.id"
                                        ref="productGroupDirect"
                                        :data="product_group"
                                        :product-category="productCategory"
                                        :first="index === 0"
                                        class="transition-all ease-in-out duration-300 w-full"
                                        @shrink-other="shrink"
                                        @open-popup="openPopup"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="overlay-right absolute right-0 h-full w-[100px] z-20" />
            </div>

            <div ref="bottomdom" class="relative h-0 w-full"></div>
        </div>
    </div>
</template>

<script>
import Swiper, { Navigation } from 'swiper';
import { mapGetters } from 'vuex';
import BlackWeekBanner from '../components/blackweek/BlackWeekBanner.vue';
import Popup from '../components/miscellaneous/Popup.vue';
import ProductCategorySingleMid from '../components/product/ProductCategorySingleMid.vue';
import ProductGroupDirect from '../components/product/ProductGroupDirect.vue';
import ProductMini from '../components/product/ProductMini.vue';
import WheelOfFortuneDecoration from '../components/WheelOfFortune/WheelOfFortuneDecoration.vue';
import WheelOfFortuneLandingPage from '../components/WheelOfFortune/WheelOfFortuneLandingPage.vue';
import WheelSparkles from '../components/WheelOfFortune/WheelSparkles.vue';
import RaffleProductBannerSlider from '../components/RaffleProductBannerSlider.vue';
import { blackweekItemActive, getRegion } from '../helpers.js';

Swiper.use([Navigation]);

export default {
    components: { BlackWeekBanner, WheelOfFortuneLandingPage, WheelOfFortuneDecoration, WheelSparkles, RaffleProductBannerSlider, Popup, ProductMini, ProductCategorySingleMid, ProductGroupDirect },

    data: () => ({
        popupOpen: false,
        screenIsLarge: false,
        loading: false,
        cartProps: {
            threshold: 0,
            offset: 0
        },
        // --- GA4: Duplicate-Schutz, nur einmal pro Seite feuern
        _viewItemListSent: false,
        productCategory: null,
        data: null,
        variant: null,
        selectedProductVariant: null,
        selectedWebinar: null
    }),

    computed: {
        ...mapGetters('product_categories', {
            productCategories: 'get'
        }),
        ...mapGetters('product_groups', {
            getProductGroupByProductCategoryId: 'getByProductCategoryId'
        }),
        ...mapGetters('settings', {
            isAllLoaded: 'isAllLoaded'
        }),
        ...mapGetters('cart', ['get', 'getItems']),

        wheel() {
            return this.get.wheel || null;
        },
        region() {
            return getRegion();
        },
        isWheelActive() {
            if (this.region !== 'de' || this.wheel?.active !== true || !this.wheel?.start || !this.wheel?.end) return false;

            const today = new Date();
            const start = new Date(this.wheel.start);
            const end = new Date(this.wheel.end);

            return start <= today && today <= end;
        },
        raffle() {
            return this.get.raffle || null;
        },
        isRaffleActive() {
            // An den Dashboard-Banner "WM Aktion 26" gekoppelt (Backend: Cart::getRaffleAttribute).
            return this.raffle?.active === true;
        },
        cartStyles() {
            if (this.cartProps.threshold < 0) {
                return {
                    'fixed-top': true,
                    'fixed-bottom': false
                };
            } else {
                return {
                    'fixed-top': false,
                    'fixed-bottom': true
                };
            }
        },
        getFooterOffset() {
            return this.cartProps.offset + 10 + 'px';
        }
    },

    emits: ['update:popupOpen'],

    watch: {
        popupOpen: function () {
            this.$emit('update:popupOpen', this.popupOpen);
        },
        isAllLoaded() {
            this.$nextTick(() => {
                this.handleScroll();
            });
        }
    },

    watch: {
        popupOpen() {
            this.$emit('update:popupOpen', this.popupOpen);
        },
        isAllLoaded() {
            this.$nextTick(() => {
                this.handleScroll();
                // fire when Vuex data finished loading
                !this._viewItemListSent && this.pushViewItemListOnce();
            });
        }
    },

    async mounted() {
        // get cart data
        await this.$store.dispatch('cart/index');

        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleScroll);
        this.initSlider();

        // initial try (in case things are already rendered)
        this.$nextTick(() => setTimeout(() => this.pushViewItemListOnce(), 0));

        // safety retries while layout/data settles
        // retry after 300ms, 1000ms (only if not sent yet)
        setTimeout(() => !this._viewItemListSent && this.pushViewItemListOnce(), 300);
        setTimeout(() => !this._viewItemListSent && this.pushViewItemListOnce(), 1000);

        // debug helper
        window.__pushListNow = () => this.pushViewItemListOnce();
    },

    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
        this.slider?.destroy(true, true);
    },

    methods: {
        blackweekItemActive,
        initSlider() {
            this.slider = new Swiper('.product-slider', {
                slidesPerView: 'auto',
                grabCursor: true,
                direction: 'horizontal',
                navigation: { nextEl: '.button-next', prevEl: '.button-prev' }
            });

            // once the slider lays out slides, try again
            setTimeout(() => !this._viewItemListSent && this.pushViewItemListOnce(), 0);
            this.slider.on('slideChange', () => {
                // optional: don’t resend if already sent
                !this._viewItemListSent && this.pushViewItemListOnce();
            });
        },

        checkForLargeScreenSize() {
            if (window.matchMedia(`(min-width:${this.$tw.theme.screens.lg})`).matches === true) {
                this.screenIsLarge = true;
            } else {
                this.screenIsLarge = false;
            }
        },
        closePopup(index) {
            this.popupOpen = index;
        },
        shrink(expandId) {
            this.$refs.productGroupDirect.forEach((productGroup) => {
                if (!(productGroup.data.id === expandId)) {
                    productGroup.shrink();
                }
            });
        },
        handleScroll() {
            this.cartProps.threshold = this.$refs.busstop?.getBoundingClientRect().bottom - window.innerHeight;
            this.cartProps.offset = document.body?.offsetHeight - this.$refs.bottomdom?.offsetTop;
            this.cartProps.cartWidth = document.body?.offsetWidth - this.$refs.busstop?.offsetWidth - this.$refs.busstop?.getBoundingClientRect().left;
            this.getFooterOffset;
        },
        async openPopup(data, productCategory, variant, selectedProductVariant, selectedWebinar) {
            this.data = data;
            this.productCategory = productCategory;
            this.selectedProductVariant = selectedProductVariant[variant];
            this.variant = variant;
            this.selectedWebinar = selectedWebinar;
            this.popupOpen = true;
        },

        // ---------- GA4 HELPERS: Kategorie-Listing ----------

        // --- kleine Utils ---
        toNum(v) {
            const n = Number(
                String(v ?? 0)
                    .replace(',', '.')
                    .replace(/[^\d.]/g, '')
            );

            return Number.isFinite(n) ? n : 0;
        },
        txt(v, locale = (this.$i18n?.locale || 'de').toLowerCase()) {
            if (!v) return '';

            if (typeof v === 'string' || typeof v === 'number') return String(v);

            if (typeof v === 'object') return v[locale] || v.de || Object.values(v)[0] || '';

            return '';
        },

        isInViewport(el) {
            if (!el) return false;

            const r = el.getBoundingClientRect();

            return r.top < innerHeight && r.bottom > 0 && r.left < innerWidth && r.right > 0;
        },
        normalizeCategoryName(catRaw) {
            const s = (catRaw || '').toString().toLowerCase();

            if (/akti/.test(s)) return 'Aktien';

            if (/ind(i|e)z/.test(s)) return 'Indizes';

            if (/krypto|crypto|btc|eth/.test(s)) return 'Krypto';

            if (/rohstoff|commod/.test(s)) return 'Rohstoffe';

            return (catRaw || '').toString();
        },

        // --- Perioden-Attribut aus Variant ziehen ---
        getPeriodAttr(variant) {
            const list = variant?.productAttributeValues?.data || variant?.product_attribute_values?.data || variant?.product_attribute_values || variant?.attributes || [];

            return Array.isArray(list) ? list.find((av) => (av?.meta?.type || av?.type || '').toString().toLowerCase() === 'period') : null;
        },

        // --- günstigste Variante inkl. Rabatt finden (robust) ---
        pickCheapestVariant(pg) {
            const variants = pg?.productVariants?.data || pg?.product_variants?.data || pg?.product_variants || pg?.variants || [];

            if (!Array.isArray(variants) || variants.length === 0) {
                return {
                    id: pg?.id,
                    slug: this.txt(pg?.slug),
                    price: 0,
                    currency: (this.$getCurrencyCode && this.$getCurrencyCode()) || 'EUR',
                    variantTitle: 'Variante'
                };
            }

            let best = null;

            for (const v of variants) {
                // 1) Bevorzugt fertige Bruttopreise
                let price = this.toNum(v?.total_end_price_gross) || this.toNum(v?.total_price_gross) || this.toNum(v?.price_gross);

                // 2) Fallback: aus base ± Rabatt berechnen
                if (!price) {
                    const base = this.toNum(v?.base_price_gross) || this.toNum(v?.price);
                    const rawDisc = this.toNum(v?.discount_percent); // evtl. 0..1 oder 0..100
                    const disc = rawDisc > 1 ? rawDisc / 100 : rawDisc;
                    price = Number((base - base * disc).toFixed(2));
                }

                // 3) Perioden-Titel holen
                const periodAttr = this.getPeriodAttr(v);
                const variantTitle = this.txt(periodAttr?.title) || 'Variante';

                if (!best || price < best.price) {
                    best = {
                        id: v?.id || v?.sku,
                        slug: this.txt(v?.slug) || this.txt(pg?.slug),
                        price,
                        currency: (this.$getCurrencyCode && this.$getCurrencyCode()) || 'EUR',
                        variantTitle
                    };
                }
            }

            return best;
        },

        buildGaItemFromGroup(pg, productCategory, index = 0, fromComp = null) {
            const locale = (this.$i18n?.locale || 'de').toLowerCase();

            const item_name = this.txt(pg?.name, locale) || this.txt(pg?.title, locale) || 'Produkt';

            const rawCat = this.txt(productCategory?.name, locale) || this.txt(productCategory?.title, locale);
            const item_category = this.normalizeCategoryName(rawCat || 'Kategorie');

            const cheapest = this.pickCheapestVariant(pg);

            const item_id = this.txt(cheapest.slug, locale) || String(cheapest.id || pg?.id || 'unknown');

            // >>> Monats-Preis aus dem Child versuchen
            let price = this.getMonthlyPriceFromChild(fromComp);

            if (price == null) {
                // Fallback: billigste Variante (Gesamtpreis)
                price = this.toNum(cheapest.price);
            }

            return {
                item_id,
                item_name,
                item_category,
                item_variant: cheapest.variantTitle || 'Variante',
                price,
                currency: cheapest.currency || 'EUR',
                quantity: 1,
                index
            };
        },

        collectVisibleListItems() {
            const comps = Array.isArray(this.$refs.productGroupDirect) ? this.$refs.productGroupDirect : [];
            const items = [];
            let idx = 0;

            for (const comp of comps) {
                const el = comp?.$el;

                if (!el || !this.isInViewport(el) || getComputedStyle(el).display === 'none') continue;

                const pg = comp?.data;
                const pc = comp?.$props?.productCategory || comp?.productCategory;

                if (!pg || !pc) continue;

                // <<< comp als 4. Argument übergeben
                items.push(this.buildGaItemFromGroup(pg, pc, idx++, comp));
            }

            return items;
        },

        getMonthlyPriceFromChild(comp) {
            try {
                const list = Array.isArray(comp?.productVariantsWritten) ? comp.productVariantsWritten : [];
                const options = Array.isArray(comp?.variants) ? comp.variants : [];

                if (!list.length || !options.length) return null;

                const rate = this.$root?.$currencyData?.[this.$getCurrencyCode()]?.rate ?? 1;

                let best = null;
                for (let i = 0; i < Math.min(list.length, options.length); i++) {
                    const pv = list[i];
                    const runtime = Number(options[i]?.runtime || 1);
                    const gross = this.toNum(pv?.total_end_price_gross ?? pv?.total_price_gross ?? pv?.price_gross ?? pv?.price);

                    if (!gross || !runtime) continue;

                    // --- Monatsbasis berechnen ---
                    const monthly = Math.round((gross / runtime) * rate * 100) / 100;

                    if (best == null || monthly < best) {
                        best = monthly;
                    }
                }

                return best;
            } catch {
                return null;
            }
        },

        pushViewItemListOnce() {
            if (this._viewItemListSent) return;

            const items = this.collectVisibleListItems();

            if (!items.length) {
                setTimeout(() => !this._viewItemListSent && this.pushViewItemListOnce(), 200);

                return;
            }

            const currency = items[0]?.currency || (this.$getCurrencyCode && this.$getCurrencyCode()) || 'EUR';
            const value = items.reduce((s, it) => s + Number(it.price || 0) * Number(it.quantity || 1), 0);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'view_item_list',
                ecommerce: { currency, value, items }
            });

            this._viewItemListSent = true;
        }

        // ---------- /GA4 HELPERS ----------
    }
};
</script>

<style scoped>
.fixed-top {
    position: absolute;
    bottom: v-bind(getFooterOffset);
    z-index: 10;
}

.fixed-bottom {
    position: fixed;
    bottom: 10px;
    z-index: 15;
}
</style>
